import { createElement, forwardRef } from 'react';
import invariant from 'invariant';
import hoistNonReactStatics from 'hoist-non-react-statics';

import useRouter from 'Hooks/useRouter';

export default function withRouter(Component) {
  const displayName = `withRouter(${ (Component.displayName || Component.name || 'Component') })`;

  const WithRouter = forwardRef((props, ref) => {
    const routerContext = useRouter();
    invariant(
      routerContext,
      `You should not use <${displayName} /> outside a <BrowserProvider /> or <MemoryProvider />`
    );
    return createElement(Component, {
      ...routerContext,
      ref,
      ...props
    });
  });

  WithRouter.displayName = displayName;
  WithRouter.WrappedComponent = Component;

  return hoistNonReactStatics(WithRouter, Component);
}
